var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconControlPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#4091CF} .fil1 {fill:white}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999787 -59c-4418116,0 -7999799,3581943 -7999799,7999894 0,4417963 3581683,8000224 7999799,8000224 4418116,0 8000224,-3582049 8000224,-8000224 0,-4418164 -3582108,-7999894 -8000224,-7999894z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M11185836 3603817l110433 -110445c334134,-334134 876272,-334134 1210406,0 334051,334075 334051,876048 -12,1210123l-110504 110504c-155445,155445 -408992,155457 -564437,35l-645863 -645709c-155480,-155457 -155492,-409051 -24,-564508zm-4895471 4896002l3843203 -3843722c155433,-155457 408992,-155469 564461,-47l645827 645697c155480,155457 155492,409051 35,564508l-3843415 3843415c-53480,53480 -112051,86646 -185433,104988l-860611 215150c-139878,34984 -277040,-3012 -379016,-104965 -101965,-101941 -139973,-239091 -105012,-378992l214973 -860552c18331,-73394 51496,-131976 104988,-185480zm-1936714 -2945706l0 6092259 6092271 0 0 -3740978c0,-109902 39165,-204484 116870,-282201l312591 -312673c116575,-116610 282650,-149658 434988,-86563 152350,63095 246425,203882 246425,368764l0 4765384c0,219839 -179303,399142 -399142,399142l-7515748 0c-219839,0 -399142,-179303 -399142,-399142l0 -7515724c0,-219839 179303,-399142 399142,-399142l4765455 0c164870,0 305646,94039 368752,246378 63095,152303 30083,318366 -86480,434965l-312520 312591c-77728,77740 -172335,116941 -282272,116941l-3741191 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControlPoint);
export default __webpack_public_path__ + "static/media/icon-control-point.44c788c7b7a5c020071c16e10cfa54a6.svg";
export { ForwardRef as ReactComponent };